import React from 'react';
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer';
var pageQuery = "3424075016";
export default function Page(_ref) {
  var mdx = _ref.data.mdx;
  return /*#__PURE__*/React.createElement(MDXRenderer, null, mdx.body);
}